import { AxiosError } from "axios";
import { api } from "config";
import { auth, UserType } from "service";
import { getAuthTokenFromLocalStorage } from "service/utils";
import { EAssignerType } from "types";

const TimeOut = 60_000;

export const getTokenBySignIn = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  try {
    const data = {
      email: email,
      password: password,
    };

    const config = {
      headers: {
        accept: "application/json",
      },
      timeout: TimeOut,
    };

    const resp = await api.post(`/auth/signin`, data, config);
    if (!resp?.data?.credentials?.access_token) {
      throw new AxiosError("Неправильная почта или пароль");
    }
    return resp.data.credentials.access_token;
  } catch (error) {
    handleError(error);
  }
};

export const getTokenBySignUp = async ({
  email,
  password,
  bin,
}: {
  email: string;
  password: string;
  bin: string;
}) => {
  try {
    const data = {
      email: email,
      password: password,
      org_name: bin,
    };

    const config = {
      headers: {
        accept: "application/json",
      },
      timeout: TimeOut,
    };

    const resp = await api.post(`/auth/signup`, data, config);
    return resp.data.credentials.access_token;
  } catch (error) {
    handleError(error);
  }
};

export const forgotPassword = async ({ email }: { email: string }) => {
  try {
    const data = {
      email: email,
    };

    const config = {
      headers: {
        accept: "application/json",
      },
      timeout: TimeOut,
    };

    const resp = await api.post(`/auth/forgot`, data, config);
    return resp.data;
  } catch (error) {
    handleError(error);
  }
};

export const restorePassword = async ({
  password,
  token,
}: {
  password: string;
  token: string;
}) => {
  try {
    const data = {
      password: password,
    };

    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${token}`,
      },
      timeout: TimeOut,
    };

    const resp = await api.post(`/auth/restore`, data, config);
    return resp.data;
  } catch (error) {
    handleError(error);
  }
};

export const getSpreadshitsList = async ({
  offset,
  limit,
  bin,
  compensation_type,
  signed_at_from,
  signed_at_until,
  company_name,
  application_no,
  application_year,
}: {
  offset: number;
  limit: number;
  bin?: string;
  compensation_type?: string;
  signed_at_from?: string;
  signed_at_until?: string;
  company_name?: string
  application_no?: number,
  application_year?: string
}) => {
  try {
    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };
    let qPath = `/spreadsheets/?limit=${limit}&offset=${offset}`;
    if (auth.IsUserType(UserType.Manager)) {
      let paramsStr = "";
      if (bin) paramsStr += `&bin=${bin}`;
      if (compensation_type)
        paramsStr += `&compensation_type=${compensation_type}`;
      if (signed_at_from) paramsStr += `&signed_at[from]=${signed_at_from}`;
      if (signed_at_until) paramsStr += `&signed_at[until]=${signed_at_until}`;
      if (company_name) paramsStr += `&company_name=${company_name}`;
      if (application_no) paramsStr += `&application_no=${application_no}`;
      if (application_year) paramsStr += `&application_year=${application_year}`

      qPath =
        `/manager/spreadsheets/?limit=${limit}&offset=${offset}` + paramsStr;
    }

    const resp = await api.get(qPath, config);
    return resp.data;
  } catch (error) {
    handleError(error);
  }
};

export const switchSpreadsheetItemStatus = async ({
  id,
  statusName,
}: {
  id: number;
  statusName: string;
}) => {
  try {
    const data = {
      application_id: id,
      status_name: statusName,
    };

    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };

    const resp = await api.patch(`/manager/spreadsheets/`, data, config);
    return resp.data.err;
  } catch (error) {
    handleError(error);
  }
};

export const switchAssignementStatus = async ({
  id,
  statusName
}: {
  id: string
  statusName: string
}) => {
  try {
    const data = {
      status_name: statusName,
    };

    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };

    const resp = await api.patch(`/assignments/${id}/status`, data, config);
    return resp.data.err;
  } catch (error) {
    handleError(error);
  }
}

export const addNewSpreadsheet = async () => {
  try {
    const data = {};

    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };

    const resp = await api.post(`/spreadsheets/`, data, config);
    return resp.data;
  } catch (error) {
    handleError(error);
  }
};

export const getListAssignments = async ({
  userType,
  limit,
  offset,
  company_name,
  application_no,
  assignment_type,
  assignee_id,
  application_year,
}: {
  userType: UserType;
  limit: number;
  offset: number;
  company_name?: string
  application_no?: number
  assignment_type?: string
  assignee_id?: string
  application_year?: string
}) => {
  try {
    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };
    let paramsStr = "";
    if (company_name) paramsStr += `&company_name=${company_name}`;
    if (application_no) paramsStr += `&application_no=${application_no}`;
    if (assignment_type) paramsStr += `&assignment_type=${assignment_type}`;
    if (assignee_id) paramsStr += `&assignee_id=${assignee_id}`;
    if (application_year) paramsStr += `&application_year=${application_year}`;

    //const qPath = `/assignments/${userType}/?limit=${limit}&offset=${offset}${paramsStr}`;
    const qPath = String(process.env.REACT_APP_BACKEND2_HOST) + `/assignments/${userType}/?limit=${limit}&offset=${offset}${paramsStr}`;
    const resp = await api.get(qPath, config);
    return resp.data;
  } catch (error) {
    handleError(error);
  }
};

export const getManagersList = async () => {
  try {
    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };
    const qPath = `/manager/managers/`;
    const resp = await api.get(qPath, config);
    return resp.data;
  } catch (error) {
    handleError(error);
  }
};

export const changeAssignee = async ({
  assignmentId,
  userId,
}: {
  assignmentId: string;
  userId: string;
}) => {
  try {
    const config = {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };
    const data = {
      user_id: userId,
    };
    const qPath = `/assignments/${assignmentId}/user`;
    const resp = await api.patch(qPath, data, config);
    return resp.data;
  } catch (error) {
    handleError(error);
  }
};

export const getParamsForAssignmentArchiveFile = async ({
  assignmentId,
}: {
  assignmentId: string;
}) => {
  try {
    const qPath = `/assignments/${assignmentId}/archive`;
    const resp = await api.get(qPath, {
      headers: {
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      responseType: "blob",
    });

    const filename = `assignment-${assignmentId}-archive.zip`;
    const blob = new Blob([resp.data], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);
    return { url, filename };
  } catch (error) {
    handleError(error);
  }
};

export const handleError = (error: any) => {
  if (error instanceof AxiosError && error.response && error.response.data) {
    if (error.response.data.message) throw new Error(error.response.data.message);
    if (error.response.data.error) throw new Error(error.response.data.error);
    if (error.response.data) throw new Error(error.response.data);
    throw new Error(error.toString());
  } else if (error instanceof AxiosError) {
    throw new Error(error.message);
  }
  throw new Error("Ошибка подключения к серверу");
};


export const queryOpenAccessToApplications = async ({ applicationId }) => {
  try {
    const config = {
      headers: {
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };
    return await api.post(`/manager/applications/${applicationId}/access`, {}, config)
  } catch (error) {
    handleError(error)
  }
}

export const getApplicationDocumentNotice = async ({ applicationId }) => {
  try {
    const resp = await api.get(`/manager/${applicationId}/notice`, {
      headers: {
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      responseType: 'blob',
    })
    const filename = `application-${applicationId}-notification.docx`;
    const url = window.URL.createObjectURL(resp.data);
    return { url, filename };
  } catch (error) {
    handleError(error)
  }
}

export const querySendApplicationDocumentNotice = async ({
  assignmentId,
  formData
}: {
  assignmentId: number,
  formData: FormData
}) => {
  try {
    const config = {
      headers: {
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
        "Content-Type": "multipart/form-data"
      },
      timeout: TimeOut,
    };
    return await api.post(
      `/assignments/${assignmentId}/notice`, formData, config);
  } catch (error) {
    handleError(error);
  }
}

export const queryCountRowsAssignment = async ({
  assignmentId
}: {
  assignmentId: string
}) => {
  try {
    const config = {
      headers: {
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };
    return await api.post(String(process.env.REACT_APP_BACKEND2_HOST) + 
`/assignments/${assignmentId}/check`, null, config)
  } catch (error) {
    handleError(error)
  }
}

export const querySendApplicationCoverLetter = async ({
  applicationId,
  assignerType,
  formData
}: {
  applicationId: string,
  assignerType: EAssignerType
  formData: FormData
}) => {
  try {
    const config = {
      headers: {
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
        "Content-Type": "multipart/form-data"
      },
      timeout: TimeOut,
    };
    return await api.post(`/assignments/applications/${applicationId}/replies/${assignerType}`, formData, config);
  } catch (error) {
    handleError(error);
  }
}

export const queryGetAssignmentHistory = async ({
  assignmentId
}: {
  assignmentId: number
}) => {
  try {
    const config = {
      headers: {
        authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
      },
      timeout: TimeOut,
    };
    return await api.get<{
      messages: [
        {
          sent_at: string,
          user_display_name: string,
          user_email: string,
          body: string,
        }
      ]
    }>(`/assignments/${assignmentId}/dialog`, config);
  } catch (error) {
    handleError(error);
  }
}